// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-703fd448]{display:none}.header-banner-card__image[data-v-703fd448]{width:100%;height:auto;display:block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
